// ABOUTME: Input/output validation schemas for TechLog → Rusada oil uplift transformation.
import {
  ZRusadaAdditionalOilAndFuel,
  ZRusadaAdditionalOilAndFuelInput,
} from '../../../../activities/api/rusada/rusada.zod';
import { ZTechlogFluidUplift } from '../../../../types/techLog/fuel.zod';
import { z } from 'zod';

/**
 * Input validation schema for the oil uplift transformation.
 * Supports both FLIGHT and TRIP_UPDATE parent entities.
 */
export const ZTechLogToRusadaOilUpliftInput = z.object({
  techlog: z.object({
    fluidUplifts: z.array(ZTechlogFluidUplift),
  }),
  rusada: z.object({
    flightId: z
      .number()
      .int()
      .describe('Veryon sector ID that owns the oil rows'),
    additionalOilAndFuel: z.array(ZRusadaAdditionalOilAndFuel),
  }),
});

export const ZTechLogToRusadaOilUpliftOutput = ZRusadaAdditionalOilAndFuelInput;

// Type exports - inferred from Zod schemas (single source of truth)
export type TechLogToRusadaOilUpliftInput = z.infer<
  typeof ZTechLogToRusadaOilUpliftInput
>;
export type TechLogToRusadaOilUpliftOutput = z.infer<
  typeof ZTechLogToRusadaOilUpliftOutput
>;
